/* Slider Extended controls, scoped to opted-in Home Featured collections. */
if (!customElements.get('featured-collection-slider')) {
  customElements.define('featured-collection-slider', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.featured-navigation-viewport');
      this.list = this.querySelector('.product-grid');
      this.arrows = this.querySelector('.featured-navigation-arrows');
      this.pagination = this.querySelector('.featured-navigation-pagination');
      if (!this.list || !this.viewport) return;
      this.items = Array.from(this.list.children);
      this.media = window.matchMedia('(max-width: 989px)');
      this.sync = this.sync.bind(this);
      this.media.addEventListener('change', this.sync);
      this.sync();
      this.imageResizeObserver = new ResizeObserver(() => {
        const width = this.viewport.clientWidth;
        if (width === this.navigationViewportWidth) return;
        this.navigationViewportWidth = width;
        this.positionArrows();
      });
      this.imageResizeObserver.observe(this.viewport);
    }

    positionArrows() {
      // Use the original card's square footprint, never the active image's height.
      const image = this.items[0]?.querySelector('.card__media');
      if (!image) return;
      const imageRect = image.getBoundingClientRect();
      const viewportRect = this.viewport.getBoundingClientRect();
      this.style.setProperty('--navigation-image-center', `${imageRect.top - viewportRect.top + imageRect.width / 2}px`);
    }

    sync() {
      const enabled = this.media.matches ? this.dataset.mobileSlider === 'true' : this.dataset.desktopSlider === 'true';
      if (!enabled || this.items.length < 2) {
        this.teardown();
        return;
      }
      if (this.instance || typeof Swiper === 'undefined') return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.list.classList.add('swiper-wrapper');
      this.items.forEach(item => item.classList.add('swiper-slide'));
      this.classList.add('featured-navigation-active');
      this.arrows.hidden = false;
      this.pagination.hidden = false;
      this.list.scrollLeft = 0;
      this.instance = new Swiper(this.viewport, {
        slidesPerView: 'auto',
        spaceBetween: gap,
        loop: this.items.length >= 3,
        rewind: this.items.length < 3,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
        grabCursor: true,
        keyboard: { enabled: true },
        navigation: {
          prevEl: this.querySelector('.featured-navigation-prev'),
          nextEl: this.querySelector('.featured-navigation-next')
        },
        pagination: {
          el: this.pagination,
          clickable: true,
          renderBullet: (index, className) => `<button type="button" class="${className}"></button>`
        },
        on: {
          init: () => this.positionArrows(),
          resize: () => this.positionArrows(),
          paginationUpdate: swiper => {
            swiper.pagination.bullets.forEach((bullet, index) => {
              bullet.setAttribute('aria-current', String(index === swiper.realIndex));
            });
          }
        }
      });
    }

    teardown() {
      if (this.instance) {
        this.instance.destroy(true, true);
        this.instance = null;
        // Swiper loops by moving nodes; desktop must retain editorial order.
        this.items.forEach(item => {
          item.classList.remove('swiper-slide');
          this.list.appendChild(item);
        });
        this.list.classList.remove('swiper-wrapper');
      }
      this.classList.remove('featured-navigation-active');
      this.arrows.hidden = true;
      this.pagination.hidden = true;
      this.pagination.replaceChildren();
    }

    disconnectedCallback() {
      this.imageResizeObserver?.disconnect();
      this.media?.removeEventListener('change', this.sync);
      if (this.list) this.teardown();
    }
  });
}
